import {Condition} from "../engine/Condition";
import {getCookie, setCookieDispatcher} from "../../../utils/cookie.js";


export class CookieCondition extends Condition {
    constructor(...args) {
        super(...args);

        this.attachListener(setCookieDispatcher, this.requestReEval);
    }

    evaluate() {
        return this.options.hasOwnProperty("equal")
            ? (getCookie(this.options.key) === this.options.equal)
            : getCookie(this.options.key) ;
    }
}
